<template>
  <div>
    <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo theme-menu"
      :background-color="menuTheme.sidebarBg"
      :text-color="menuTheme.sidebarText"
      :active-text-color="menuTheme.sidebarActive"
      router
      :collapse="isCollapse"
    >
      <div class="el-menu-item txt">
        <span>{{ appTitle }}</span>
      </div>
      <template v-for="item in routers" v-if="!item.hidden && item.children">
        <router-link
          v-if="
            hasOneShowingChildren(item.children) && !item.children[0].children && !item.alwaysShow
          "
          :to="item.path + '/' + item.children[0].path"
          :key="item.children[0].name"
        >
          <el-menu-item
            :index="item.path + '/' + item.children[0].path"
            :class="{ 'submenu-title-noDropdown': !isNest }"
            @click="clickMenu(item.children[0])"
          >
            <i
              v-if="item.children[0].meta && item.children[0].meta.icon"
              :class="'iconfont ' + item.children[0].meta.icon"
            ></i>
            <span
              v-if="item.children[0].meta && item.children[0].meta.title"
              slot="title"
            >{{ item.children[0].meta.title }}</span>
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.path" :key="item.name">
          <template slot="title">
            <i v-if="item.meta && item.meta.icon" :class="'iconfont ' + item.meta.icon"></i>
            <span v-if="item.meta && item.meta.title" slot="title">
              {{
              item.meta.title
              }}
            </span>
            <!-- <el-badge v-if="item.meta.id==22" type="danger"  size="mini" :value="3" :max="99" /> -->
          </template>

          <template v-for="child in item.children" v-if="!child.hidden">
            <sidebar-item
              :is-nest="true"
              class="nest-menu"
              v-if="child.children && child.children.length > 0"
              :routers="[child]"
              :key="child.path"
            ></sidebar-item>
            <router-link v-else :to="item.path + '/' + child.path" :key="child.name">
              <el-menu-item :index="item.path + '/' + child.path" @click="clickMenu(child)">
                <i v-if="child.meta && child.meta.icon" :class="'iconfont ' + child.meta.icon"></i>
                <span v-if="child.meta && child.meta.title" slot="title">
                  {{
                  child.meta.title
                  }}
                </span>
              </el-menu-item>
            </router-link>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { APP_TITLE } from "@/config/app";

export default {
  props: ["isCollapse"],
  computed: {
    ...mapGetters(["routers"]),
    ...mapState("theme", {
      menuTheme: (state) => state.theme,
    }),
    appTitle() {
      return APP_TITLE;
    },
  },
  data() {
    return {
      isNest: false
    };
  },
  created() {
    console.log("routers", this.routers);
  },
  methods: {
    hasOneShowingChildren(children) {
      // console.log("children", children, !children[0].children);
      const showingChildren = children.filter(item => {
        // console.log("showingChildren", !item.hidden, item);
        return !item.hidden;
      });
      if (showingChildren.length === 1) {
        // console.log("true", showingChildren);
        return true;
      }
      // console.log("false");
      return false;
    },
    // 点击把菜单的名字传出去
    clickMenu(val) {
      this.$store.commit("pushtags", val);
    }
  }
};
</script>
<style lang='less' scoped>
.txt {
  text-align: center;
  font-size: 20px;
  color: var(--theme-sidebar-text, #bfcbd9);
  background-color: var(--theme-sidebar-bg, #304156);
  cursor: default;
  &:hover {
    background: var(--theme-sidebar-bg, #304156);
  }
}
.el-menu {
  border-right: 0;
}
/deep/ .iconfont {
  vertical-align: middle;
  margin-right: 12px;
  margin-left: 3px;
  width: 24px;
  text-align: center;
  font-size: 20px;
}
.item-group > ul > .el-menu-item > .iconfont {
  vertical-align: middle;
  margin-right: 8px;
  margin-left: 3px;
  width: 24px;
  text-align: center;
  font-size: 16px;
}
/deep/ .el-menu-item-group__title {
  padding: 0 !important;
}
/deep/ .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px !important;
  height: 100%;
  transition: width 0.01s;
  -moz-transition: width 0.01s;
  -webkit-transition: width 0.01s;
  -o-transition: width 0.01s;
  // min-height: 400px;
}
/deep/ .el-menu--collapse {
  width: 75px !important;
  transition: width 0.01s;
  -moz-transition: width 0.01s;
  -webkit-transition: width 0.001s;
  -o-transition: width 0.01s;
}
</style>